import React from "react";
import { Spin, message, Input } from "antd";
import { LoadingOutlined } from "@/utils/antdIcon";
import { LoginFormContext, LoginFormContextType } from "../utils";
import GlobalContext from "@/context/GlobalContext";
import { IconArrowLeft } from "@/components/icon";
import { useTranslation } from "react-i18next";
import { AuthDataRes } from "@/types/LoginPage";
import styles from "../index.module.less";

export default function NameInputForm({
  authCode,
  onCreateUser
}: {
  authCode: string;
  onCreateUser: (data: AuthDataRes) => void;
}) {
  const { t } = useTranslation("common");
  const {
    mobile,
    userName,
    onUserNameChange,
    navigate,
    setResendLastTs,
    onMobileChange
  } = React.useContext<LoginFormContextType>(LoginFormContext);
  const { appRuntimeEnv, service, onGlobalError } = React.useContext(GlobalContext);
  // const [nickname, setNickname] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const loadingComp = (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 16, color: "white" }} spin />} />
  );

  async function createUser() {
    // TODO
    try {
      setLoading(true);
      const content = await service.focusService.createUser({
        userName,
        mobile,
        authCode,
        countryCode: "86"
      });
      setLoading(false);
      if (content) {
        // TODO
        // 换取token
        service.authService
          .fastLogin(
            {
              accessToken: content.accessToken
            },
            {
              "x-token": content.accessToken
            }
          )
          .then((data: AuthDataRes) => {
            onCreateUser(data);
          })
          .catch((e: any) => {
            onGlobalError(e);
          });
      }
    } catch (error) {
      setLoading(false);
    }
    // navigate('stepNewTeam');
  }

  return (
    <div className={styles.mobileForm}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start"
        }}
      >
        <div
          className={styles["hover-color"]}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer"
          }}
          onClick={() => {
            onMobileChange("");
            setResendLastTs(-1);
            setTimeout(() => {
              navigate("step1");
            }, 0);
          }}
        >
          <span
            style={{
              marginRight: 5,
              fontSize: 14
            }}
          >
            {IconArrowLeft}
          </span>
          {t("login.back")}
        </div>
      </div>
      <div className={styles.inputCodeTitle}>{t("login.enterNickname")}</div>
      <p className={styles.inputTip}>{t("login.nicknameDesc")}</p>
      <div
        style={{
          paddingBottom: 10
        }}
      >
        <div className={styles.mobileInput}>
          <Input
            autoFocus
            placeholder={t("login.enterNicknamePlaceholder")}
            value={userName}
            onKeyDown={(e: any) => {
              const { keyCode } = e;
              if (keyCode === 13) {
                // checkMobileCb();
              }
            }}
            onChange={(e: any) => {
              onUserNameChange(e.target.value);
            }}
          />
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          bottom: "30px",
          width: "320px",
          marginBottom: "100px"
        }}
      >
        <div
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}
          onClick={() => {
            // checkMobileCb();
            // TODO 创建新用户
            createUser();
          }}
          className={styles.btn}
          style={
            !loading && userName && userName.length
              ? {
                  opacity: 1,
                  cursor: "pointer"
                }
              : {
                background: "#BABFC5"
              }
          }
        >
          {loading && <div>{loadingComp}</div>}
          <div
            style={{
              margin: 8,
              fontSize: 16,
              color: "white"
            }}
          >
            {t("nextStep")}
          </div>
        </div>
      </div>
    </div>
  );
}
